import { Link } from "react-router-dom";
import { Clock, MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function ApplicationCard({ app, index = 0 }) {
  const vehicle = `${app.brand || ""} ${app.model || ""}`.trim() || app.title;
  const serviceLine = (app.services || []).join(" + ");
  return (
    <Reveal delay={(index % 3) * 0.07}>
      <Link
        to={`/uygulamalar/${app.slug}`}
        data-testid={`application-card-${app.slug}`}
        className="group flex h-full flex-col overflow-hidden border border-white/10 bg-neutral-900 transition-colors hover:border-gold/40"
      >
        <div className="relative aspect-[16/11] overflow-hidden">
          {(app.cover_image || app.after_image) ? (
            <img
              src={app.cover_image || app.after_image}
              alt={app.title}
              loading="lazy"
              className="h-full w-full object-cover grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
            />
          ) : (
            <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-gradient-to-b from-neutral-900 to-black" data-testid={`application-card-placeholder-${app.slug}`}>
              <span className="px-4 text-center font-oswald text-2xl font-bold uppercase tracking-[0.2em] text-white/10">{app.brand}</span>
              <span className="font-oswald text-[10px] uppercase tracking-[0.25em] text-gold/60">Fotoğraflar Yakında</span>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/30 to-transparent" />
          {app.year && (
            <span className="absolute left-4 top-4 border border-gold/40 bg-black/70 px-3 py-1 font-oswald text-[11px] font-bold uppercase tracking-[0.15em] text-gold backdrop-blur">
              {app.year} Model
            </span>
          )}
        </div>
        <div className="flex flex-1 flex-col p-5">
          {serviceLine && (
            <span data-testid={`application-card-service-${app.slug}`} className="font-oswald text-[11px] font-bold uppercase tracking-[0.18em] text-gold">{serviceLine}</span>
          )}
          <h3 className="mt-1.5 font-display text-lg font-medium text-white transition-colors group-hover:text-gold">{vehicle}</h3>
          <p className="mt-2 flex-1 text-sm text-neutral-400 line-clamp-2">{app.summary}</p>
          <div className="mt-4 flex flex-wrap gap-4 border-t border-white/10 pt-4 text-xs text-neutral-500">
            {app.district && <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-gold" /> {app.district}</span>}
            {app.duration && <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-gold" /> {app.duration}</span>}
          </div>
        </div>
      </Link>
    </Reveal>
  );
}
